var map = {
	"./cart/cart.module": [
		"./src/app/sji/cart/cart.module.ts",
		"cart-cart-module"
	],
	"./claims/claims.module": [
		"./src/app/sji/claims/claims.module.ts",
		"claims-claims-module"
	],
	"./home/home.module": [
		"./src/app/sji/home/home.module.ts",
		"home-home-module"
	],
	"./order/order.module": [
		"./src/app/sji/order/order.module.ts",
		"order-order-module"
	],
	"./shiptoaddress/shiptoaddress.module": [
		"./src/app/sji/shiptoaddress/shiptoaddress.module.ts",
		"shiptoaddress-shiptoaddress-module"
	],
	"./userprofile/userprofile.module": [
		"./src/app/sji/userprofile/userprofile.module.ts",
		"userprofile-userprofile-module"
	],
	"./vendor/vendor.module": [
		"./src/app/sji/vendor/vendor.module.ts",
		"vendor-vendor-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;